import styled from "styled-components";

import { Code } from "@components";

import { CIProvider } from "../types";

interface Props {
  ciProvider: CIProvider;
  configYaml: string;
  customConfigHref: string;
}

const Container = styled.div`
  width: 800px;
  padding: 20px 28px 8px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: var(--dark-gray1);
`;

/**
 * Content dialog that pops up when you review the snippet
 * from manual CI setup
 */
export const ConfigSnippetDialogContent: React.FC<Props> = (props) => {
  let scanMessage = "all files";
  if (props.ciProvider === "github") {
    scanMessage = "changed files in PRs";
  } else if (props.ciProvider === "gitlab") {
    scanMessage = "changed files in MRs";
  }

  return (
    <Container>
      <Code
        multiline
        copyable
        dark
        style={{
          backgroundColor: "var(--global-dark-gray)",
          width: "100%",
        }}
      >
        {props.configYaml}
      </Code>
      <div>
        The first scan checks everything in the project. After, by default,
        scans apply to {scanMessage} and only report new findings.
      </div>
      <div>
        You can customize your configuration, following our{" "}
        <a
          href={props.customConfigHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          Sample configs
        </a>
        .
      </div>
    </Container>
  );
};
